import { cn } from '@/lib/utils';
import { Checkbox } from '@/components/ui/primitives';

export interface PickablePlan {
  id: string;
  name: string;
  facilityType: 'hospital' | 'lab' | 'pharmacy';
  moduleFlags: string[];
}

export function PlanPicker({
  plans,
  chosen,
  onChange,
}: {
  plans: PickablePlan[] | undefined;
  chosen: string[];
  onChange: (next: string[]) => void;
}) {
  const toggle = (plan: PickablePlan) => {
    onChange(chosen.includes(plan.id) ? chosen.filter((id) => id !== plan.id) : [...chosen, plan.id]);
  };

  return (
    <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
      {(plans ?? []).map((plan) => {
        const picked = chosen.includes(plan.id);
        return (
          <label
            key={plan.id}
            className={cn('flex cursor-pointer items-start gap-2 rounded-md border p-3 text-sm', picked && 'border-primary/40 bg-primary/5')}
          >
            <Checkbox className="mt-0.5" checked={picked} onCheckedChange={() => toggle(plan)} />
            <span>
              <span className="font-medium">{plan.name}</span>
              <span className="block text-xs text-muted-foreground">{plan.moduleFlags.length} modules</span>
            </span>
          </label>
        );
      })}
    </div>
  );
}
